import { createFileRoute } from "@tanstack/react-router";
import UseCasesPage from "@/pages/UseCasesPage";

const TITLE = "Cas d'usage — Trouver des clients quand on est indépendant | Thiia";
const DESC =
  "Coachs, consultants, freelances et TPE : comment Thiia trouve vos prospects, prépare des relances personnalisées et suit vos clients, sans abonnement.";

export const Route = createFileRoute("/use-cases")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://thiia.app/use-cases" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://thiia.app/use-cases" }],
  }),
  component: UseCasesPage,
});
